/**
 * Calculation:
 * Assume it will take 20 minutes (1200 seconds) to complete the update,
 * therefore should increase by 100/1200 = 0.083% per second.
 */
const PROGRESS_INCREMENT_PER_SEC = 0.0833;
const MAX_TIMED_PROGRESS = 95; // Only display timed progress up to 95%

/**
 * Calculate the progress increment assuming a 20mins total length.
 *
 * @param currentProgress - The current progress value.
 * @param intervalMs - The interval in milliseconds. Default is 1 seconds.
 * @returns The next progress value, capped at 95%.
 */
export const calculateSwUpdateProgress = (
  currentProgress: number,
  intervalMs: number = 1000,
) => {
  const increment = PROGRESS_INCREMENT_PER_SEC * (intervalMs / 1000);
  const nextValue = currentProgress + increment;

  if (nextValue < 0) {
    return 0;
  } else if (Math.ceil(nextValue) >= MAX_TIMED_PROGRESS) {
    return MAX_TIMED_PROGRESS;
  }

  return nextValue;
};
